export const Quotes = [
	{
		id: 1,
		quote:
			'It has become appallingly obvious that our technology has exceeded our humanity.',
		author: 'Albert Einstein, Physicist',
	},
	{
		id: 2,
		quote: 'Technology is best when it brings people together.',
		author: 'Matt Mullenweg, (CEO) Automattic Inc.',
	},
	{
		id: 3,
		quote: "It's not a faith in technology. It's faith in people.",
		author: 'Steve Jobs, (Co-founder) Apple',
	},
	{
		id: 4,
		quote:
			'Any sufficiently advanced technology is indistinguishable from magic.',
		author: 'Arthur C. Clarke, Author',
	},
	{
		id: 5,
		quote:
			'Just because something doesn’t do what you planned it to do doesn’t mean it’s useless.',
		author: 'Thomas Edison, Inventor',
	},
	{
		id: 6,
		quote:
			'The art challenges the technology, and the technology inspires the art.',
		author: 'John Lasseter, Director',
	},
	{
		id: 7,
		quote: 'The human spirit must prevail over technology.',
		author: 'Albert Einstein, Physicist',
	},
	{
		id: 8,
		quote: 'Innovation is the outcome of a habit, not a random act.',
		author: 'Sukant Ratnakar, Author',
	},
	{
		id: 9,
		quote: "It's not that we use technology, we live technology.",
		author: 'Godfrey Reggio, Director',
	},
	{
		id: 10,
		quote:
			"Once a new technology rolls over you, if you're not part of the steamroller, you're part of the road.",
		author: 'Stewart Brand, Writer',
	},
];

// export const Quotes = [
//   {
//     id:1,
//     quote: "It's not that we use technology, we live technology.",
//     author: "Godfrey Reggio, Director",
//   },
//   {
//     id:2,
//     quote: "Once a new technology rolls over you, if you're not part of the steamroller, you're part of the road.",
//     author: "Stewart Brand, Writer",
//   }
// ]
